import React from 'react';
import { Navigate } from 'react-router-dom';
import { RoutingStep } from 'router/models/Routes';
import { Analytics } from './pages/Analytics';
import Deals from './pages/Deals';
import Team from './pages/Team';
import Configuration from './pages/Configuration';
import Branding from './pages/Branding';

export default [
  {
    path: 'analytics',
    element: Analytics,
  },
  {
    path: 'deals',
    element: Deals,
  },
  {
    path: 'team',
    element: Team,
  },
  {
    path: 'configuration',
    element: Configuration,
  },
  {
    path: 'branding',
    element: Branding,
  },
  { index: true, element: <Navigate to="analytics" replace /> },
] as Array<RoutingStep>;
